
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faqs/[group]",
      function () {
        return require("private-next-pages/faqs/[group]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faqs/[group]"])
      });
    }
  